import Editor from './editor';
import MenuTree from './menu-tree';

export default {
  Editor,
  MenuTree,
};
